export const prettifyKey = (key: string) => key.replace(/[_]/g, ' ');

export const prettifyValue = (value: string | number) => {
  if (typeof value === 'number') {
    return value.toLocaleString();
  }
  return value;
};
